












































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import SelectSingleMonth from '@/shared/date-picker/single-month/select-single-month.component.vue';
import moment from 'moment';
import MainButton from '@/shared/buttons/main-button.component.vue';
import LabelSlot from '@/shared/slots/label-slot.component.vue';
import Rules from '@/shared/rules/rules';
import ContractItem from '@/domain/contract/entity/contract-item.entity';
import ContractService from '@/domain/contract/service/contract.service';
import PerformBillingInfoModal from '../contract-info/itens/perform-billing/perform-billing-info-modal.component.vue';
import PerformBillingConfirmItensModal from '../contract-info/itens/perform-billing/perform-billing-confirm-itens-modal.component.vue';

@Component({
  components: {
    SelectSingleMonth,
    MainButton,
    LabelSlot,
    PerformBillingInfoModal,
    PerformBillingConfirmItensModal,
  },
})
export default class BillingItensModalExecute extends Vue {
  @Prop({
    type: Boolean,
    default: false,
  }) showModal!: boolean;

  @Prop({
    type: Boolean,
    default: false,
  }) loading!: boolean;

  @Prop({
    type: Boolean,
    default: false,
  }) isBillingDaily!: boolean;

  @Prop({
    type: Array,
    default: () => [],
  }) items!: Array<ContractItem>;

  rules: Rules = new Rules();

  competence: string = '';

  frequency: string = '';

  frequencyOptions = [
    { value: 'SINGLE', text: 'Único' },
    { value: 'MONTHLY', text: 'Mensal' },
    { value: 'ALL', text: 'Todos' },
  ]

  showModalConfirmItens: boolean = false;

  showModalSingleBillingInfo: boolean = false;

  itensWithInvoice: string[] = [];

  numberItemsWithInvoice: number[] = [];

  created() {
    this.competence = moment().format('YYYY-MM');
  }

  formatCompetence(competence: string): string {
    return moment(competence).format('MM/YYYY');
  }

  get alertMessage(): string {
    return 'Se o faturamento do item do contrato for '
      + 'realizado fora da data de aniversário do contrato, os dados de consumo '
      + 'podem ainda não ter sido apurados pela unidade. Verifique se todas as '
      + 'informações estão atualizadas antes de prosseguir.'
  }

  get textCompetence(): string {
    return this.isBillingDaily ? 'Competência do Aniversário' : 'Competência';
  }

  get itemsToBill(): string[] {
    if (this.frequency === 'ALL') {
      return this.items.map((item) => item.id);
    }
    return this.items
      .filter((item) => item.frequency && item.frequency.value === this.frequency)
      .map((item) => item.id);
  }

  get disabledBillingButton(): boolean {
    return this.itemsToBill.length === 0 || !this.frequency;
  }

  handleNumberItemsWithInvoice() {
    this.numberItemsWithInvoice = this.items
      .filter((item) => this.itensWithInvoice.includes(item.id))
      .map((item) => item.number);
  }

  handleExecuteAllItens() {
    this.showModalConfirmItens = false;
    this.executeBillingItens();
  }

  handleExecuteItensNotInvoiced() {
    this.showModalConfirmItens = false;
    const itemsToBill = this.itemsToBill.filter((item) => !this.itensWithInvoice.includes(item));
    this.$emit('executeBillingItens', { competence: this.competence, items: itemsToBill });
  }

  cancel() {
    this.$emit('cancel');
  }

  executeBillingItens() {
    this.$emit('executeBillingItens', { competence: this.competence, items: this.itemsToBill });
  }

  async processCheckPreInvoiceExists(items: string[], competence: string): Promise<boolean> {
    for (let i = 0; i < items.length; i += 1) {
      // eslint-disable-next-line no-await-in-loop
      const exists = await ContractService.existsPreInvoiceItem(items[i], competence);
      if (exists) {
        return true
      }
    }
    return false
  }

  async processCheckInvoiceExists(items: string[], competence: string): Promise<void> {
    await items.reduce<Promise<void>>(
      (promise, item) => promise.then(() => ContractService.existsInvoiceItem(item, competence)
        .then((exists) => {
          if (exists) {
            this.itensWithInvoice.push(item);
          }
        })),
      Promise.resolve(),
    );
  }

  private async checkPreInvoiceAndInvoiceExists(items: string[], competence: string) {
    this.$emit('loadingBillingItens', true);
    if (!this.isBillingDaily) {
      const existsPreInvoice = await this.processCheckPreInvoiceExists(items, competence);
      if (existsPreInvoice) {
        this.showModalSingleBillingInfo = existsPreInvoice;
        this.$emit('loadingBillingItens', false);
        return
      }
      await this.processCheckInvoiceExists(items, competence);
      if (this.itensWithInvoice.length > 0) {
        this.handleNumberItemsWithInvoice();
        this.showModalConfirmItens = true;
        this.$emit('loadingBillingItens', false);
        return;
      }
    }
    this.executeBillingItens();
  }
}
